export var InternetUseCase;
(function (InternetUseCase) {
    InternetUseCase["SURFING"] = "surfing";
    InternetUseCase["STREAMING"] = "streaming";
    InternetUseCase["VIDEOCALLS"] = "videocalls";
    InternetUseCase["GAMING"] = "gaming";
    InternetUseCase["SMALL_DEVICES"] = "small_devices";
    InternetUseCase["SECURE_NET_VIDEO_CALLS"] = "secure_net_video_calls";
    InternetUseCase["SECURE_NET_SURFING"] = "secure_net_surfing";
    InternetUseCase["HIGH_SPEED_WORK"] = "high_speed_work";
})(InternetUseCase || (InternetUseCase = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["TELIA_EMPLOYEE"] = "TELIA_EMPLOYEE";
    DiscountType["SPECIAL_PRICE"] = "SPECIAL_PRICE";
})(DiscountType || (DiscountType = {}));
export const SALESCHANNEL_ARGOS = 'ARGOS';
